import DownloadTicket from './DownloadTicket'

export default DownloadTicket
